import { Fragment, useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import ActionButton from "../Common/ActionButton";
// api
import { Signle_Call } from "../Api/Api";

const ExamResult = (props) => {
  const [examResultTypes] = useState({
    passed: {
      icon: "/img/certificate.gif",
      alt: "قبول",
      buttonText: "دانلود گواهینامه",
    },
    faileded: {
      icon: "/img/failed.gif",
      alt: "مردود",
      buttonText: "شروع مجدد آزمون",
    },
  });

  const [examResults, setExamResults] = useState({
    exam_id: null,
    certificate_url: "",
    exam_passed: 0,
    result_description: "نامشخص",
    right_answers_count: 0,
    total_questions_count: 0,
    wrong_answers_count: 0,
  });

  const handle_getExamInfo = async () => {
    const apiCall = () => {
      const apiCall = async (tools) => {
        const ApiCall = await Signle_Call(tools);
        return ApiCall;
      };
      return new Promise((result) => {
        result(
          apiCall({
            method: "get",
            data: false,
            path: `exam/${examResults.exam_id}`,
          })
        );
      });
    };
    const getExam_result = await apiCall();
    if (getExam_result.type) {
      let data = getExam_result.response.data;
      data.exam_id = getExam_result.response.data.questions[0].pivot.exam_id;
      props.history.push("/exam", { ...data });
    }
  };
  const downloadCertificate = (url) => {
    var a = document.createElement("a");
    a.href = url;
    console.log(url);
    a.download = "";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  useEffect(() => {
    if (props.location.state.exam_passed === 1) {
      localStorage.removeItem("lastExam");
    }
    localStorage.removeItem("examTimeLeft");
    props.location.state && setExamResults(props.location.state);
  }, []);

  // const [result, setResults] = useState({})

  return (
    <div className="ExamResults col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div className="ExamResults_wrapper contain col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div className="lockOut col-12 col-sm-12 col-md-12 col-lg-4 col-xl-5">
          <img
            src={
              examResultTypes[examResults.exam_passed ? "passed" : "faileded"]
                .icon
            }
            alt={
              examResultTypes[examResults.exam_passed ? "passed" : "faileded"]
                .alt
            }
            className="examResults_icon"
          />
          <p className="examResults_description">
            {examResults.result_description}
          </p>
          <ActionButton
            haveCertificate={examResults.certificate_url === ""}
            WhiteMode={true}
            OnLoadMode={false}
            DisableMode={examResults.certificate_url === ""}
            ClassNames={[
              "examResults_button",
              examResults.certificate_url === "" ? "disabled" : "",
            ]}
            DisableOnLoadMode={true}
            Text={
              examResultTypes[examResults.exam_passed ? "passed" : "faileded"]
                .buttonText
            }
            DoAction={() =>
              examResults.certificate_url === ""
                ? () => {}
                : examResults.exam_passed
                ? downloadCertificate(examResults.certificate_url)
                : handle_getExamInfo()
            }
            Type={false}
          />
        </div>
        <div className="examAllResults col-12 col-sm-12 col-md-12 col-lg-8 col-xl-7">
          <h2 className="page_title">جزییات آزمون</h2>
          <div className="results_box col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            {examResults.exam_passed === -1 ? (
              <h4
                className="detail_title"
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                آزمون شما به‌پایان رسید، پس از اصلاح آزمون نمره شما گزارش داده
                می شود
              </h4>
            ) : (
              <>
                <div className="detail all_questions col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <h4 className="detail_title">تعداد کل سوالات</h4>
                  <p className="detail_data">
                    {examResults.total_questions_count}
                  </p>
                </div>
                <div className="detail col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <h4 className="detail_title">تعداد سوالات درست</h4>
                  <p className="detail_data rightOnes">
                    {examResults.right_answers_count}
                  </p>
                </div>
                <div className="detail col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <h4 className="detail_title">تعداد سوالات نادرست</h4>
                  <p className="detail_data wrongOnes">
                    {examResults.wrong_answers_count}
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ExamResult);
